import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { BindingInfo } from '../binding'
import { Observable, Subscription } from 'rxjs'
import { UIEvent } from '../../../services/event.service'
/**
 * セル範囲
 *【対象範囲:targetRegion:string】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-cell-region',
  templateUrl: './cell-region.html',
  styles: [`
    
  `]
})
export class CellRegion extends BaseWidget {
  /**
   * 対象範囲
   */
  @Input() targetRegion:string

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get includingCellPattern():RegExp {
    return new RegExp(
      '^' + this.targetRegion
        .replace(/\[\*\]/g, '\\.(\\d+)')
        .replace(/\[(\d+)\]/g, '(\\.$1)')
        .replace(/\.\*/g, '\\.[^.]+') + '$'
    )
  }
  
  eventSubscription: Subscription
  
  ngOnInit() {
    this.eventSubscription = this.eventHub.event$
    .filter(e => e.type.includes('spreadsheet-internal::'))
    .subscribe(e => {
      if (!e.source) return
      const type = e.type.split('::')[1]
      const binding:BindingInfo = e.source
      const m = this.includingCellPattern.exec(binding.path)
      if (!m) return
      this.eventHub.next({
        id: this.id,
        type: type,
        source: e.source,
        ...(m.length > 1 ? {index: Number(m[m.length-1])} : {}),
      })
    })
  }
  
  ngOnDestroy() {
    this.eventSubscription.unsubscribe()
  }
}


// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/cell-region/cell-region.component.ts